@if (open) {
  <div class="viewer-container" (click)="close.emit()">
    <div class="viewer-content">
      <!-- <a class="close-viewer" (click)="close.emit()"> Close Image </a> -->
      <img class="main-img" [src]="imageURL" />
    </div>
  </div>
}
